<template>
  <Layout />
</template>

<script>
import Layout from "./components/Layout.vue";

export default {
  components: { Layout },
  created() {
    this.$store.dispatch("loadUserFromLocalStorage");
  },
};
</script>

<style>
body {
  background: #f6f7fb;
  font-family: "Inter", "Segoe UI", Arial, sans-serif;
  color: #22223b;
  margin: 0;
}
#app {
  min-height: 100vh;
  background: #f6f7fb;
}
</style>
